module.exports = __webpack_public_path__ + "img/item3.d4710a34.png";